import { Add } from '@tunasong/icons'
import type { TypographyProps } from '../primitives/index.js'
import { Typography } from '../primitives/index.js'
import classNames from 'classnames'
import type { FC, MouseEvent } from 'react'
import { IconButton } from '../primitives/index.js'

export interface ActionHeaderProps extends TypographyProps {
  className?: string
  title: string
  onAction(event: MouseEvent): void
}

export const ActionHeader: FC<ActionHeaderProps> = props => {
  const { className, title, onAction, children, variant = 'subtitle1', ...restProps } = props

  return (
    <div
      className={classNames(className)}
      style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
    >
      <Typography display="inline" variant={variant} {...restProps}>
        {title}
      </Typography>
      {children}
      <IconButton onClick={onAction}>
        <Add />
      </IconButton>
    </div>
  )
}
